export default __webpack_public_path__ + "static/media/regine.b6446125.jpg";